import { Edit, CheckCircle, CheckCircleOutline } from "@material-ui/icons";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../assets/img/no-record.png";
import {
  getSystemBannersAction,
  updateSystemBannerStatusAction,
} from "../../actions/SystemBannersActions";
import * as code from "./../../config/Constants";
import moment from "moment";

class SystemBannersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      systemBanners: [],
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
  }
  columns = [
    {
      name: "Title",
      selector: "title",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Start date",
      selector: "startDate",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "End date",
      selector: "endDate",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Status",
      selector: "status",
      width: "115px",
    },

    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];
  componentWillMount() {
    this.getAllSystemBanners(this.state.page);
  }
  getAllSystemBanners(pageIndex) {
    this.setState({
      showLoader: true,
    });
    this.props
      .getSystemBannersAction(this.state.recordPerPage, pageIndex)
      .then((result) => {
        this.setState({
          systemBanners: this.props.systemBanners || [],
          showLoader: false,
        });
      });
  }

  changePage = async (page) => {
    this.getAllSystemBanners(page - 1);
    // if (this.state.isSearched) {
    //   this.searchVendor(this.state.searchParam, page - 1);
    // } else {
    //   this.getVendorsList(page - 1);
    // }
  };

  changeStatus(bannerId) {
    let data = {
      id: bannerId,
    };
    this.props
    .updateSystemBannerStatusAction(data)
      .then((response) => {
        this.getAllSystemBanners(this.state.page);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];
    for (var i = 0, len = this.state.systemBanners.length; i < len; i++) {
      let systemBanner = this.state.systemBanners[i];
      let data = {
        title: systemBanner.title,

        startDate: systemBanner.startDate
        ? moment(systemBanner.startDate).format("MM-DD-YYYY")
        : "-",

        endDate: systemBanner.endDate
        ? moment(systemBanner.endDate).format("MM-DD-YYYY")
        : "-",

        status: systemBanner.Isactive ? (
          <CheckCircle
            className="check"
            style={{ color: "green", cursor: "pointer" }}
            onClick={() => this.changeStatus(systemBanner._id)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            style={{ cursor: "pointer" }}
            onClick={() => this.changeStatus(systemBanner._id)}
          />
        ),

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.props.history.push({
                  pathname: "/systemBannersForm",
                  state: {
                    id: systemBanner._id,
                  },
                });
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs="4">
            <h4 className="title-med mt-0 pt-1">System Banners</h4>
          </Col>
          <Col align="right" className="contact-btn">
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                this.props.history.push({
                  pathname: "/systemBannersForm",
                });
              }}
            >
              Add System Banner
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalBanners}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    systemBanners: state.reducer.systemBanners,
    totalBanners: state.reducer.totalBanners,
  };
};

export default connect(mapStateToProps, {
  getSystemBannersAction,
  updateSystemBannerStatusAction,
})(SystemBannersList);
